import {useEffect} from 'react';
import {useLocation, withRouter} from 'react-router-dom';

export const ScrollToTop = withRouter(({history}) => {
  const {pathname} = useLocation();

  // Braces matter: an implicit return hands React the scrollTo result as the effect's
  // cleanup function, and calling it on the next route change unmounts the whole app.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; 
});
 
